angular.module('wbDashboard')
.controller('MilestoneModUpdateController', ['$scope', '$q', '$location', '$filter', '$timeout', '$uibModal', 'User', 'PlanService', 'Milestone', 'RiskScore', 'Misc', 'Message',
function ($scope, $q, $location, $filter, $timeout, $uibModal, User, PlanService, Milestone, RiskScore, Misc, Message) {
    $scope.mod.action = "update";
    //default pages
    $scope.mod.defaultPages = function() {
        //this can probably be removed as it's likely no longer needed
        //will be replaced moment milestone type controller is loaded
        // angular.copy(['amount', 'portfolio-type', 'allocation-start', 'auto-deposit'], $scope.pages);
    };
    $scope.mod.defaultPages();

    Milestone.getAvailable().then(function(data) {
        $scope.milestoneDefaults = data;
    });
    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.overview = overview;
            Milestone.setBirthDate($scope.overview.user.birth_date);
        }
    });
    $scope.$watch(function() { return User.getMilestones($scope.$stateParams.msId); }, function(milestone) {
        if (milestone) {
            Milestone.setMilestoneUpdateFromObject(milestone);
            // $scope.milestone = Milestone.ms; //need to keep same obj reference from parent
            $scope.milestoneOriginal = milestone;

        } else {
            Milestone.ms = Milestone.loadingMilestone;
            $scope.milestone = Milestone.ms;
        }

        Milestone.getGlideRecommend($scope.milestone);

    });

    $scope.mod.submitMilestone = function() {
        var data= Milestone.prepareSubmitData($scope.milestone);

        delete data.allocation;
        // delete data.accounts;

        $scope.pageData.sending = true;
        $scope.pageData.updating = true;

        Milestone.update(data).then(function() {
            User.retrieveOverview(true);
            User.retrieveMilestones($scope.$stateParams.msId, true);

            User.retrieveMilestonePositions($scope.$stateParams.msId, true);

            // PlanService.user.retrieveAutos();

            //clear milestone list in portfolioPositions
            PlanService.user.clearPortfolioExtra();

            $scope.$state.go("base.receipt", { receipt: {
                "action": "UPDATE_MILESTONE",
                "type": $scope.milestone.type,
                "milestone_name": $scope.milestone.name,
                "msId": $scope.milestone.id,
                // "amount": $scope.milestone.initial_deposit,
                // "auto_amount": $scope.milestone.auto_deposit.amount,
                // "old_auto_amount": $scope.milestone.extra.auto_deposit_original
            }});

        }).catch(function() {
            $scope.pageData.sending = false;
            $scope.pageData.updating = false;
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        });
    };

    $scope.mod.submitAllocation = function() {
        $scope.pageData.sending = true;
        $scope.pageData.updating = true;

        var data = {
            allocation_start: $scope.milestone.allocation.allocation_start,
            allocation_end: $scope.milestone.allocation.allocation_start,
            cash_start: 0,
            cash_end: 0,
        };
        return PlanService.user.setMilestoneAllocation($scope.milestone.id, data).then(function() {
            User.retrieveOverview(true);
            User.retrieveMilestones($scope.$stateParams.msId, true);

            User.retrieveMilestonePositions($scope.$stateParams.msId, true);

            //clear milestone list in portfolioPositions
            PlanService.user.clearPortfolioExtra();

            $scope.$state.go("base.receipt", { receipt: {
                    "action": "UPDATE_MILESTONE",
                    "type": $scope.milestone.type,
                    "milestone_name": $scope.milestone.name,
                    "msId": $scope.milestone.id,
                    // "amount": $scope.milestone.initial_deposit,
                    // "auto_amount": $scope.milestone.auto_deposit.amount,
                    // "old_auto_amount": $scope.milestone.extra.auto_deposit_original
                }});
        }).catch(function() {
            $scope.pageData.sending = false;
            $scope.pageData.updating = false;
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        });

    };

    $scope.mod.openHelp = function(page) {

        var $modalScope = $scope.$new();

        $modalScope.pageData = {
            page: page,
            help: {}
        };
        $modalScope.pageData.help[page] = true;

        $modalScope.portfolio = $scope.portfolio;

        var modalInstance = $uibModal.open({
            templateUrl: "milestone-modal-help.tpl.html",
            size: 'md',
            scope: $modalScope,
            windowClass: 'milestone-modal-help'
        });
        modalInstance.result.catch(angular.noop);

    };

    /**
     * Set defaults anytime milestone is selected
     */







    /**
     * Reset all initial milestone values
     * @param type
     */
    $scope.setPageDefaults = function() {
        Milestone.setSectionDefaults($scope.$stateParams.page);
    };











    /**
     ******************************************
     * Page Related
     ******************************************
     */
    $scope.mod.initPage.preCheck = function(page) {
        if (!$scope.milestone.id && page !== $scope.pages[0]) { //make sure always starts on first page if milestone not loaded yet
            //should have id in next iteration...
            // $scope.$state.go('base.milestone-mod.update.steps', {page: $scope.pages[0]}, {location: "replace"});
            // return false
        }
        return true;
    };
    $scope.mod.initPage.update = function(page) {
        switch (page) {
        }
    };

    $timeout(function() {
        //need time for sub-milestone controller to load
        $scope.mod.initPage($scope.$stateParams.page);
    });

}]);
